import { useEffect, useSyncExternalStore } from "react";

type EditorObservation = {
	projectId: string;
	entityId: string;
	view: "form" | "graph";
	draft: unknown;
	saved: unknown;
};
let current: EditorObservation | null = null;
const listeners = new Set<() => void>();
function subscribe(listener: () => void) {
	listeners.add(listener);
	return () => { listeners.delete(listener); };
}
function emit() { for (const listener of listeners) listener(); }

export function useDemoEditorObservation(projectId: string, entityId: string, view: EditorObservation["view"], draft: unknown, saved: unknown) {
	useEffect(() => {
		const observation = { projectId, entityId, view, draft, saved };
		current = observation;
		emit();
		return () => {
			if (current === observation) { current = null; emit(); }
		};
	}, [projectId, entityId, view, draft, saved]);
}
export function useObservedDemoEditor() {
	return useSyncExternalStore(subscribe, () => current, () => null);
}
